const General = {};

General.getUniqueID = () => Math.random().toString(36).substr(2, 9);

// The small delay gives a better user experience (as it gives a fast response)
General.QueryDelay = 700; // NB! Don't increase delay (it's better to optimize queries or use includes)

General.compareAsNumbers = (a, b) => {

  if (!a && !b) {
    return true;
  }

  return (1 * a === 1 * b);
}

export default General;
